<script setup lang="ts">
import { ref } from 'vue'
import { Permission } from '../../../../types/auth'
import SalesQuotationsForm from './SalesQuotationsForm.vue'
import { RecordStatus } from '../../../../types/models'
import ListTemplate from '../../../../components/ui/common/ListTemplate.vue'
import { FilterField, TableAction, TableField } from '../../../../components/table/table'

const endPoint = '/clients/revenue/sales/sales-quotations/'
const title = 'Sales Quotations'
const selectedData = ref<any | null>(null)
const showForm = ref(false)
const formMode = ref<'create' | 'edit' | 'view' | 'showQuickView' | 'toggleStatus'>('view')
const refreshData = ref(false)

const permissions = ref<Permission[]>();

const fields: TableField[] = [
  { name: 'date_time', caption: 'Date', sortable: true, fieldType: 'date' },
  { name: 'document_no', caption: 'Ref. No', sortable: true, fieldType: 'text'},
  { name: 'warehouse', caption: 'Warehouse', sortable: true, fieldType: 'text' },
  { name: 'outlet', caption: 'Outlet', sortable: true, fieldType: 'text' },
  { name: 'customer', caption: 'customer', sortable: true, fieldType: 'text' },
  { name: 'sales_channel', caption: 'Channel', sortable: true, fieldType: 'text' },
  { name: 'delivery_date', caption: 'Delivery By', sortable: true, fieldType: 'date' },
  { name: 'credit_term', caption: 'Payment Terms', sortable: true, fieldType: 'text' },
  { name: 'sales_person', caption: 'Sales Rep', sortable: true, fieldType: 'text' },
  { name: 'customer_reference', caption: 'customer Reference', sortable: true, fieldType: 'text'},
  { name: 'to_deliver', caption: 'To Deliver', sortable: false, fieldType: 'boolean' },
  { name: 'record_status', caption: 'Status', sortable: false, fieldType: 'text' },
]


const actions: TableAction[] = [
{
    name: "edit-quote",
    icon: "Pencil",
    variant: "primary",
    title: "Edit Quotaion",
    permission: "create",
    dropdown: false,
    visible: (item) => item.record_status == 'Approved',
  },
];

const filterFields: FilterField[] = [
  {
    name: 'active',
    label: 'Status',
    type: 'select',
    value: '',
    options: [
      { id: '1', name: 'Active' },
      { id: '0', name: 'Inactive' }
    ],
  },
]

const changeMode = (
  mode: "create" | "edit" | "view" | "showQuickView" | "toggleStatus"
) => {
  formMode.value = mode;
  showForm.value = mode === "view" || mode === "edit" || mode === "create";
};

const handleTableActions = (action: string, data: any) => {
  console.log('action1=', action)
  if (action === 'edit-quote') {
    selectedData.value = data;
    formMode.value = 'edit';
    showForm.value = true;
  }
}
const handleData = (data : any) => {
  selectedData.value = data
}

const record_status = ref<RecordStatus[]>([]);
const handleLists = (list: any) => {
  record_status.value = list['record_status']
}

const handlePermissions = (perm: Permission[]) => {
  permissions.value = perm
}

const listViewRef = ref<InstanceType<typeof ListTemplate> | null>(null);
const viewDocument = (data : any, title: string, path: string) => {
  if (listViewRef.value) {
    listViewRef.value.viewDocument(data, title, path);
  }
}

</script>

<template>
  <ListTemplate  ref="listViewRef" :endPoint = "endPoint" :title = "title" :fields = "fields" :actions = "actions" :filterFields ="filterFields" @permissions="handlePermissions"
  :tabList = "[]" :refreshData = "refreshData" @mode="changeMode"  @show="showForm = true"
  :showForm="showForm" @lists="handleLists" @custom="handleTableActions"
  :allow-disable="false" :allow-edit="false" @data="handleData">
  <template #form-view>
    <SalesQuotationsForm
      v-if="showForm"
      :permissions="permissions"
      :data="selectedData"
      :record-status="record_status"
      @view-document="viewDocument"
      :end-point="endPoint"
      :title="title"
      :mode="formMode"
      @save="refreshData = !refreshData"
      @close="showForm = !showForm"
    />
  </template>
  </ListTemplate>
</template>